import { t, Trans } from '@lingui/macro';
import { Button, Rating, Stack, Text, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';

import { useLocal } from '../../lib/local/use-local';
import { GradeTitleValue, selectTitleGrade } from './grade-title';

const GradeDescription = ({ value }: { value?: GradeTitleValue }) => {
  useLocal();
  const emptyText = selectTitleGrade(0);

  if (!value) return <span>{emptyText}</span>;

  return <span>{selectTitleGrade(value) || emptyText}</span>;
};

type TFeedback = {
  rating: number;
  message?: string;
};

type LeaveReviewFormProps = {
  onSubmit?: (feedback: TFeedback) => void;
  disabled?: boolean;
};

export const AddFeedbackForm = ({
  onSubmit,
  disabled,
}: LeaveReviewFormProps) => {
  useLocal();

  const form = useForm({
    initialValues: {
      rating: 0 as GradeTitleValue,
      message: '',
    },

    validate: {
      rating: (value) => value === 0 && t`Пожалуйста, выберите оценку`,
    },
  });

  const handleSubmit = (values: TFeedback) => {
    onSubmit?.(values);
  };

  const maybeGradeDescription = form.errors.rating ? (
    <Text color="red">{form.errors.rating}</Text>
  ) : (
    <GradeDescription value={form.values.rating} />
  );

  const placeholder = t`Хотите оставить сообщение?`;

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack justify="center" align="center" spacing={8}>
        <Rating
          count={5}
          // @ts-expect-error 'size' is also support number
          size={50}
          {...form.getInputProps('rating')}
        />

        {maybeGradeDescription}
        <Textarea
          mt={16}
          size="md"
          w="100%"
          placeholder={placeholder}
          {...form.getInputProps('message')}
        />
        <Button type="submit" size="md" mt={8} disabled={disabled} fullWidth>
          <Trans>Отправить отзыв</Trans>
        </Button>
      </Stack>
    </form>
  );
};
